import { useQuery } from "@tanstack/react-query";
import type {
  ActionType,
  EntityType,
  ActionStatus,
  SortDirection,
} from "../types/api/logs";
import { fetchUserActions } from "../services/userLogs";
import { fetchModeratorActions } from "../services/moderatorLogs";

export const useActionsQuery = (
  isUserActions: boolean,
  search: string = "",
  page: number,
  limit: number,
  actionType?: ActionType,
  entityType?: EntityType,
  status?: ActionStatus,
  ordering?: SortDirection,
  userId?: string,
  entityId?: string,
  createdFrom?: string,
  createdTo?: string,
  appScreen?: string,
  clientVersion?: string,
  options?: {
    enabled?: boolean;
  }
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: [
      isUserActions ? "user-actions" : "moderator-actions",
      search,
      page,
      limit,
      actionType,
      entityType,
      status,
      ordering,
      userId,
      entityId,
      createdFrom,
      createdTo,
      ...(isUserActions ? [appScreen, clientVersion] : []),
    ],
    queryFn: () => {
      const baseParams = {
        search: search || undefined,
        limit,
        offset: (page - 1) * limit,
        action_type: actionType,
        entity_type: entityType,
        status,
        ordering,
        user_id: userId,
        entity_id: entityId,
        created_from: createdFrom,
        created_to: createdTo,
      };

      if (isUserActions) {
        return fetchUserActions({
          ...baseParams,
          app_screen: appScreen,
          client_version: clientVersion,
        });
      } else {
        return fetchModeratorActions(baseParams);
      }
    },
    retry: 0,
    enabled: options?.enabled ?? true,
  });
};
